import { fetchApiJson, trackError } from '@vend/utilities'

export interface LspayMerchantSettings {
  /** Whether LSP cash discounting is enabled for the outlet. */
  enabled: boolean
  /** The LSP cash discounting rate as a percentage (e.g. `4` for 4%). */
  rate: number
}

export interface LSPCashDiscountingParams {
  /** The active outlet id, used in the request path. */
  outletId: string
}

/**
 * Fetch the cash discounting settings for the given outlet from the LSPay
 * outlet cash-discounting settings endpoint.
 *
 * @returns The merchant settings, or `null` if the outlet id is missing or the
 *          request fails.
 */
export const fetchLspayCashDiscountSettings = async ({
  outletId,
}: LSPCashDiscountingParams): Promise<LspayMerchantSettings | null> => {
  if (!outletId) {
    return null
  }

  try {
    const response = await fetchApiJson(
      `/api/2.0/lspay/outlets/${outletId}/cash-discounting/settings`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      }
    )

    return response as LspayMerchantSettings
  } catch (err) {
    trackError('Failed to fetch LSPay merchant settings', err)
    return null
  }
}
